import React from 'react';
import YouTube from 'react-youtube';

const VideoPlayer = ({ videoId, autoplay, controls }) => {
  const onReady = (event) => {
    if (autoplay) {
      event.target.playVideo();
    }
  };

  const opts = {
    playerVars: {
      // Show controls or not. 0 = don't show, 1 = show
      controls: controls ? 1 : 0,
      // Autoplay or not. 0 = no, 1 = yes
      autoplay: autoplay ? 1 : 0,
    },
  };

  return (
    <div className="video-container">
      <YouTube videoId={videoId} opts={opts} onReady={onReady} />
    </div>
  );
};

export default VideoPlayer;
